import Envoy from "../util/Envoy";

class StorageProvider extends Envoy {
  public async getImageAsBlob(objectName: string): Promise<string> {
    try {
      const response = await this.conn.get(`/storage/image/${objectName}`);
      if (response.data.messages?.length) {
        throw new Error(response.data.messages.join("\n"));
      }
      return response.data.data;
    } catch (error) {
      console.error("Erro ao obter imagem como blob:", error);
      throw error;
    }
  }
}

export default StorageProvider;
